import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export const CHECKOUT_URL = 'https://checkout.ebookpoint.shop/cart/59750125142097:1';
export function Button({
  children,
  className = '',
  onClick
}: ButtonProps) {
  const handleClick = () => {
    if (onClick) onClick();
    window.location.href = CHECKOUT_URL;
  };
  return <button onClick={handleClick} className={`w-full bg-teal-600 hover:bg-teal-700 text-white font-bold py-4 px-6 rounded-xl shadow-[0_4px_0_rgb(15,118,110)] active:shadow-[0_0px_0_rgb(15,118,110)] active:translate-y-1 transition-all text-lg uppercase tracking-wide flex flex-col items-center justify-center gap-1 ${className}`} data-id="element-177">
      {children}
    </button>;
}